// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__m4irk","right":"Footer_right__3Wk6w","buttons":"Footer_buttons__2g_w9"};